import ScrollPage, {SectionItem} from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import Validations from "../../Content/Achievements/Validations";
import Advantages from "../../Content/Advantages/Advantages";
import GlobalIP from "../../Content/GlobalIP/GlobalIP2";
import Goals from "../../Content/Goals/Goals2";
import IPStrategy from "../../Content/IPStrategy/IPStartegy2";
import ResNDev from "../../Content/OurApproach/ResNDev";

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Goals",        id: "goals" },
  { label: "Advantages",   id: "advantages" },
  { label: "R&D",          id: "rnd" },
  { label: "Validation",   id: "validation" },
  { label: "IP Strategy",  id: "ip-strategy" },
  { label: "Global IP",    id: "global-ip" }
];


const OurStory: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <Goals />
    </Section>
    <Section section={Sections[1].id}>
      <Advantages />
    </Section>
    <Section section={Sections[2].id}>
      <ResNDev />
    </Section>
    <Section section={Sections[3].id}>
      <Validations />
    </Section>
    <Section section={Sections[4].id}>
      <IPStrategy />
    </Section>
    <Section section={Sections[5].id}>
      <GlobalIP />
    </Section>
  </ScrollPage>
);

export default OurStory;